import { ColorOption, Product } from '../types'

const IMG = {
  bands: 'https://cdn.magicpatterns.com/patterns/generated-images/37682231-dde0-45ce-a49b-2a2ca3a84e5b.jpg',
  gloves:
    'https://cdn.magicpatterns.com/patterns/generated-images/b36cc6c8-f3fc-4923-ac72-38e55a2d55e1.jpg',
  ankle:
    'https://cdn.magicpatterns.com/patterns/generated-images/8cac96f9-e326-483b-b1a9-187724fe3fdb.jpg',
  corrector:
    'https://cdn.magicpatterns.com/patterns/generated-images/b73918f1-2ae7-4f00-98d7-9f2271cf3466.jpg',
  kit: 'https://cdn.magicpatterns.com/patterns/generated-images/1529ac00-8842-4da7-9d2c-6be4a8ef8c9b.jpg',
  grips:
    'https://cdn.magicpatterns.com/patterns/generated-images/d732119e-0c88-4a73-87ab-a23452da7cf9.jpg',
  rope: 'https://cdn.magicpatterns.com/patterns/generated-images/5276281d-d57d-4d72-bde2-b67175a7e48d.jpg',
}

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/86af9161-e1b5-49b4-8224-279ed89394ad.jpg',
  about:
    'https://cdn.magicpatterns.com/patterns/generated-images/5bfd6399-b305-4aa8-945a-a40320508794.jpg',
  quote:
    'https://cdn.magicpatterns.com/patterns/generated-images/3bd48e6b-9569-4ed2-8ae9-dfea85ab46c1.jpg',
  ...IMG,
}

export const COLORS: ColorOption[] = [
  { id: 'pink', name: 'Rosa', hex: '#e91e8c' },
  { id: 'teal', name: 'Turquesa', hex: '#4ecdc4' },
  { id: 'purple', name: 'Violeta', hex: '#7c5cff' },
  { id: 'black', name: 'Negro', hex: '#111111' },
]

export const CATEGORIES = [
  {
    id: 'bandas' as const,
    label: 'Bandas Elásticas',
    short: 'Bandas',
    image: IMG.bands,
    count: 8,
    blurb: 'Tela antideslizante, 3 niveles de tensión.',
  },
  {
    id: 'guantes' as const,
    label: 'Guantes',
    short: 'Guantes',
    image: IMG.gloves,
    count: 6,
    blurb: 'Palma reforzada, cero callos.',
  },
  {
    id: 'tobilleras' as const,
    label: 'Tobilleras',
    short: 'Tobilleras',
    image: IMG.ankle,
    count: 5,
    blurb: 'Peso ajustable de 0,5 a 3 kg.',
  },
  {
    id: 'correctores' as const,
    label: 'Correctores',
    short: 'Correctores',
    image: IMG.corrector,
    count: 4,
    blurb: 'Soporte lumbar y postura activa.',
  },
  {
    id: 'kits' as const,
    label: 'Kits',
    short: 'Kits',
    image: IMG.kit,
    count: 3,
    blurb: 'Todo lo esencial en un solo pack.',
  },
]

function pick(ids: string[]): ColorOption[] {
  return COLORS.filter((c) => ids.includes(c.id))
}

export const PRODUCTS: Product[] = [
  {
    id: 'p1',
    slug: 'banda-elastica-pro',
    name: 'Banda Elástica Pro',
    category: 'bandas',
    categoryLabel: 'Bandas',
    price: 1290,
    salePrice: 990,
    shortDescription: 'Banda de tela con agarre antideslizante, tensión media.',
    description:
      'La Banda Elástica Pro está confeccionada en tela de doble capa con banda interna de silicona, para que nunca se enrolle ni se corra durante las sentadillas o los hip thrust. Su tensión media la vuelve ideal para activar glúteos y trabajar cadera sin sobrecargar la rodilla.',
    howToUse:
      'Colocá la banda por encima de las rodillas, con las costuras hacia afuera. Mantené los pies a la altura de las caderas y empujá hacia afuera durante todo el movimiento. Usá 2 a 3 series de 15 repeticiones como activación previa.',
    images: [IMG.bands, IMG.kit, IMG.grips, IMG.rope],
    colors: pick(['pink', 'teal', 'purple', 'black']),
    stock: 42,
    rating: 4.9,
    reviews: 214,
    bestSeller: true,
  },
  {
    id: 'p2',
    slug: 'guantes-grip-black',
    name: 'Guantes Grip Black',
    category: 'guantes',
    categoryLabel: 'Guantes',
    price: 1590,
    shortDescription: 'Palma de microfibra reforzada, muñequera ajustable.',
    description:
      'Guantes de entrenamiento con palma de microfibra reforzada y dorso de malla transpirable. Protegen las manos del roce de la barra y las mancuernas, evitando ampollas y callos sin perder sensibilidad en el agarre.',
    howToUse:
      'Ajustá la muñequera con el velcro sin apretar la circulación. Lavá a mano con agua fría y dejá secar al aire para conservar la elasticidad.',
    images: [IMG.gloves, IMG.grips, IMG.kit, IMG.bands],
    colors: pick(['black', 'pink']),
    stock: 6,
    rating: 4.7,
    reviews: 128,
    bestSeller: true,
  },
  {
    id: 'p3',
    slug: 'tobilleras-ajustables-3kg',
    name: 'Tobilleras Ajustables 3kg',
    category: 'tobilleras',
    categoryLabel: 'Tobilleras',
    price: 2190,
    shortDescription: 'Par de tobilleras de neopreno con peso regulable.',
    description:
      'Par de tobilleras de neopreno con bolsillos de arena de hierro removibles, para regular la carga entre 0,5 y 3 kg por pierna. El interior acolchado evita el roce en el tobillo durante caminatas, patadas y trabajo de core.',
    howToUse:
      'Retirá o agregá bolsillos según la carga deseada y ajustá el velcro por encima del hueso del tobillo. Empezá con la carga mínima y subí de a 0,5 kg por semana.',
    images: [IMG.ankle, IMG.kit, IMG.bands, IMG.grips],
    colors: pick(['black', 'teal']),
    stock: 18,
    rating: 4.8,
    reviews: 96,
    isNew: true,
  },
  {
    id: 'p4',
    slug: 'corrector-postural-active',
    name: 'Corrector Postural Active',
    category: 'correctores',
    categoryLabel: 'Correctores',
    price: 2490,
    salePrice: 1990,
    shortDescription: 'Soporte lumbar y de hombros para uso diario.',
    description:
      'Corrector postural con soporte lumbar rígido y tiras cruzadas en los hombros. Alinea la columna y descarga la zona cervical, pensado para quienes pasan muchas horas sentados o levantan peso a diario.',
    howToUse:
      'Colocalo sobre una remera, ajustá primero la faja lumbar y después las tiras de los hombros. Usalo entre 30 y 60 minutos por día durante la primera semana y aumentá progresivamente.',
    images: [IMG.corrector, IMG.kit, IMG.gloves, IMG.bands],
    colors: pick(['black', 'pink']),
    stock: 24,
    rating: 4.6,
    reviews: 74,
  },
  {
    id: 'p5',
    slug: 'kit-zadar-esencial',
    name: 'Kit ZADAR Esencial',
    category: 'kits',
    categoryLabel: 'Kits',
    price: 3990,
    salePrice: 3290,
    shortDescription: '3 bandas + guantes + bolso de malla.',
    description:
      'El pack con el que arrancan la mayoría de nuestros clientes: tres bandas de distinta tensión, un par de guantes Grip Black y un bolso de malla para llevar todo al gimnasio.',
    howToUse:
      'Usá la banda liviana para activación, la media para el trabajo principal y la fuerte para series pesadas de glúteo. Guardá todo en el bolso de malla para que respire después de entrenar.',
    images: [IMG.kit, IMG.bands, IMG.gloves, IMG.ankle],
    colors: pick(['pink', 'teal', 'black']),
    stock: 12,
    rating: 5,
    reviews: 61,
    bestSeller: true,
    isNew: true,
  },
  {
    id: 'p6',
    slug: 'grips-competition',
    name: 'Grips Competition',
    category: 'guantes',
    categoryLabel: 'Guantes',
    price: 1890,
    shortDescription: 'Grips de cuero con muñequera para barra y anillas.',
    description:
      'Grips de cuero curtido con muñequera de neopreno, diseñados para dominadas, kipping y trabajo en anillas. Reducen la fricción y mejoran el agarre en series largas.',
    howToUse:
      'Humedecé levemente el cuero antes de entrenar y aplicá magnesio. Ajustá la muñequera para que el grip quede tenso sobre la palma.',
    images: [IMG.grips, IMG.gloves, IMG.bands, IMG.kit],
    colors: pick(['black', 'teal']),
    stock: 4,
    rating: 4.5,
    reviews: 38,
  },
  {
    id: 'p7',
    slug: 'banda-elastica-heavy',
    name: 'Banda Elástica Heavy',
    category: 'bandas',
    categoryLabel: 'Bandas',
    price: 1490,
    shortDescription: 'Máxima tensión para trabajo pesado de glúteo.',
    description:
      'Versión de máxima tensión de nuestra banda de tela. Pensada para atletas que ya dominan el patrón de movimiento y necesitan más resistencia en puentes de glúteo, abducciones y sentadillas.',
    howToUse:
      'Ubicala por encima de la rodilla y controlá la fase excéntrica. Si la banda te empuja las rodillas hacia adentro, bajá una tensión.',
    images: [IMG.bands, IMG.grips, IMG.kit, IMG.ankle],
    colors: pick(['purple', 'black']),
    stock: 31,
    rating: 4.8,
    reviews: 87,
  },
  {
    id: 'p8',
    slug: 'soga-speed-rope',
    name: 'Soga Speed Rope',
    category: 'kits',
    categoryLabel: 'Kits',
    price: 1190,
    shortDescription: 'Cable de acero recubierto con rulemanes de precisión.',
    description:
      'Soga de velocidad con cable de acero recubierto en PVC y rulemanes sellados en los mangos, para giros rápidos sin trabas. Largo regulable según altura.',
    howToUse:
      'Paráte sobre el centro del cable: los mangos deben llegar a la altura de las axilas. Recortá el excedente y fijá los tornillos.',
    images: [IMG.rope, IMG.kit, IMG.gloves, IMG.bands],
    colors: pick(['pink', 'black']),
    stock: 0,
    rating: 4.4,
    reviews: 29,
    isNew: true,
  },
  {
    id: 'p9',
    slug: 'tobilleras-lite-1kg',
    name: 'Tobilleras Lite 1kg',
    category: 'tobilleras',
    categoryLabel: 'Tobilleras',
    price: 1490,
    shortDescription: 'Livianas, ideales para pilates y movilidad.',
    description:
      'Tobilleras de 1 kg por lado con forro de algodón, pensadas para pilates, movilidad y rehabilitación. Bajo perfil para que no molesten en ejercicios de suelo.',
    howToUse:
      'Ajustá por encima del tobillo y mantené el core activo durante todo el movimiento. Ideal para series de 20 repeticiones.',
    images: [IMG.ankle, IMG.bands, IMG.corrector, IMG.kit],
    colors: pick(['teal', 'purple']),
    stock: 27,
    rating: 4.7,
    reviews: 52,
  },
  {
    id: 'p10',
    slug: 'faja-lumbar-power',
    name: 'Faja Lumbar Power',
    category: 'correctores',
    categoryLabel: 'Correctores',
    price: 2790,
    shortDescription: 'Faja de neopreno con doble ajuste para peso muerto.',
    description:
      'Faja lumbar de neopreno con doble sistema de ajuste y varillas flexibles. Aumenta la presión intraabdominal y protege la zona lumbar en levantamientos pesados.',
    howToUse:
      'Colocala sobre el ombligo, inhalá profundo y ajustá. Usala solo en las series pesadas para no debilitar la musculatura estabilizadora.',
    images: [IMG.corrector, IMG.grips, IMG.kit, IMG.gloves],
    colors: pick(['black']),
    stock: 9,
    rating: 4.6,
    reviews: 44,
  },
  {
    id: 'p11',
    slug: 'guantes-mesh-flex',
    name: 'Guantes Mesh Flex',
    category: 'guantes',
    categoryLabel: 'Guantes',
    price: 1390,
    shortDescription: 'Ultra transpirables, sin dedos, agarre de silicona.',
    description:
      'Guantes sin dedos con dorso de malla y detalles de silicona en la palma. La opción más liviana del catálogo, ideal para clases de funcional y verano.',
    howToUse:
      'Lavá a mano después de cada uso intensivo. Guardalos abiertos para mantener la forma.',
    images: [IMG.gloves, IMG.bands, IMG.rope, IMG.kit],
    colors: pick(['pink', 'teal', 'black']),
    stock: 35,
    rating: 4.5,
    reviews: 66,
  },
  {
    id: 'p12',
    slug: 'kit-glute-builder',
    name: 'Kit Glute Builder',
    category: 'kits',
    categoryLabel: 'Kits',
    price: 4490,
    shortDescription: '3 bandas + tobilleras + guía de entrenamiento.',
    description:
      'Pack completo de tren inferior: tres bandas de tela, un par de tobilleras ajustables y una guía digital de 8 semanas escrita junto a entrenadores uruguayos.',
    howToUse:
      'Seguí la guía de 8 semanas: 3 sesiones semanales combinando bandas y tobilleras, con progresión de carga cada dos semanas.',
    images: [IMG.kit, IMG.ankle, IMG.bands, IMG.grips],
    colors: pick(['pink', 'purple', 'black']),
    stock: 7,
    rating: 4.9,
    reviews: 40,
    bestSeller: true,
  },
]

export function getProductBySlug(slug: string): Product | undefined {
  return PRODUCTS.find((p) => p.slug === slug)
}

export function getProductById(id: string): Product | undefined {
  return PRODUCTS.find((p) => p.id === id)
}
